class ShadeSliderComponent extends SliderComponent {
  constructor() {
    super();
  //console.log(this.slider);

   //this.enableSliderLooping = true;

    this.sliderControlWrapper = this.querySelector('.slider-buttons');

      if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slider__slide');

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));



    
  }

    update() {
      
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;



    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

     this.sliderItems.forEach((sliderItem) => {
      sliderItem.classList.remove('slide--active');
      sliderItem.removeAttribute('aria-current');
    });

    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);

    this.sliderItems[this.currentPage - 1].classList.add('slide--active');
    this.sliderItems[this.currentPage - 1].setAttribute('aria-current', true);
    

   

  }


    linkToSlide(event) {
    event.preventDefault();

    console.log(this);


     this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });

     this.sliderItems.forEach((sliderItem) => {
      sliderItem.classList.remove('slide--active');
      sliderItem.removeAttribute('aria-current');
    });

     event.currentTarget.classList.add('slider-counter__link--active');
    event.currentTarget.setAttribute('aria-current', true);
  
  
  
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('shade-slider-component', ShadeSliderComponent);


